// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mass-upload-container .mass-upload-header {
  font-size: 1.75rem;
  font-weight: bold;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.mass-upload-container .remove {
  text-transform: uppercase;
}
.mass-upload-container .rating-container {
  padding: 1.25rem 0 1.875rem;
}
.mass-upload-container .modal-close {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: calc(100% - 30px);
  top: 0.25rem;
}
.mass-upload-container .modal-close .close-icon {
  cursor: pointer;
  max-width: 40px;
}
.mass-upload-container ion-row {
  margin-top: 1.3125rem;
}
.mass-upload-container ion-row ion-col {
  padding: 0 0.4375rem;
  display: contents;
}
.mass-upload-container ion-row ion-col .common-input {
  width: 100%;
  position: relative;
  border: 1px solid #ccc;
}
.mass-upload-container ion-row ion-col:first-child {
  padding-left: 0;
}
.mass-upload-container ion-row ion-col:last-child {
  padding-right: 0;
}

.uploadImage-bottom-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1.5625rem 1.875rem;
}
.uploadImage-bottom-container .cancel {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;
  cursor: pointer;
}
.uploadImage-bottom-container .cancel:hover {
  font-weight: 600;
}
.uploadImage-bottom-container .product-button ion-button {
  --background: var(--ion-color-primary);
  width: 100px;
  height: 46px;
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.125rem;
  letter-spacing: 0.4px;
  --box-shadow: none;
  --border-radius: 0;
}

.progress {
  background-color: #D5DADC;
  border-radius: 100px;
  display: flex;
  font-size: 1.2rem;
  height: 0.375rem;
  overflow: hidden;
  margin-top: 0.75rem;
}

.progress-bar {
  align-items: center;
  background-color: #0081ca;
  color: #fff;
  display: flex;
  justify-content: center;
}

.select-label-text {
  position: relative;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mass-upload/mass-upload.component.scss"],"names":[],"mappings":"AACC;EACC,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,0BAAA;AAAF;AAGC;EACC,yBAAA;AADF;AAIC;EACC,2BAAA;AAFF;AAKC;EACC,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,YAAA;AAHF;AAKE;EACC,eAAA;EACA,eAAA;AAHH;AAOC;EACC,qBAAA;AALF;AAOE;EACC,oBAAA;EACA,iBAAA;AALH;AAOG;EACC,WAAA;EACA,kBAAA;EACA,sBAAA;AALJ;AASE;EACC,eAAA;AAPH;AAUE;EACC,gBAAA;AARH;;AAaA;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;AAVD;AAYC;EACC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;EACA,gDAAA;EACA,eAAA;AAVF;AAYE;EACC,gBAAA;AAVH;AAeE;EACC,sCAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAbH;;AAkBA;EACC,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAfD;;AAkBA;EACC,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAfD;;AAkBA;EACC,kBAAA;EACA,YAAA;AAfD","sourcesContent":[".mass-upload-container {\n\t.mass-upload-header {\n\t\tfont-size: 1.75rem;\n\t\tfont-weight: bold;\n\t\tcolor: var(--ion-color-primary-black);\n\t\ttext-transform: capitalize;\n\t}\n\n\t.remove {\n\t\ttext-transform: uppercase;\n\t}\n\n\t.rating-container {\n\t\tpadding: 1.25rem 0 1.875rem;\n\t}\n\n\t.modal-close {\n\t\tposition: absolute;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\twidth: calc(100% - 30px);\n\t\ttop: 0.25rem;\n\n\t\t.close-icon {\n\t\t\tcursor: pointer;\n\t\t\tmax-width: 40px;\n\t\t}\n\t}\n\n\tion-row {\n\t\tmargin-top: 1.3125rem;\n\n\t\tion-col {\n\t\t\tpadding: 0 0.4375rem;\n\t\t\tdisplay: contents;\n\n\t\t\t.common-input {\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tborder: 1px solid #ccc;\n\t\t\t}\n\t\t}\n\n\t\tion-col:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\tion-col:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n}\n\n.uploadImage-bottom-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 1.5625rem 1.875rem;\n\n\t.cancel {\n\t\tfont-weight: 400;\n\t\tfont-size: 0.9375rem;\n\t\tline-height: 1.125rem;\n\t\tletter-spacing: 0.4px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary-black);\n\t\tpadding: 0.8125rem 2.1875rem 0.8125rem 2.1875rem;\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\n\t.product-button {\n\t\tion-button {\n\t\t\t--background: var(--ion-color-primary);\n\t\t\twidth: 100px;\n\t\t\theight: 46px;\n\t\t\tfont-weight: 600;\n\t\t\tfont-size: 0.9375rem;\n\t\t\tline-height: 1.125rem;\n\t\t\tletter-spacing: 0.4px;\n\t\t\t--box-shadow: none;\n\t\t\t--border-radius: 0;\n\t\t}\n\t}\n}\n\n.progress {\n\tbackground-color: #D5DADC;\n\tborder-radius: 100px;\n\tdisplay: flex;\n\tfont-size: 1.2rem;\n\theight: 0.375rem;\n\toverflow: hidden;\n\tmargin-top: 0.75rem;\n}\n\n.progress-bar {\n\talign-items: center;\n\tbackground-color: #0081ca;\n\tcolor: #fff;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.select-label-text {\n\tposition: relative;\n\tborder: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
